exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".homepage-tabbed-filter .tooltip{opacity:1;min-width:230px;position:absolute!important}.homepage-tabbed-filter .tooltip.top{top:unset!important;bottom:100%!important}.homepage-tabbed-filter .tooltip-inner{background-color:#cecece;color:var(--primary-dark);padding:7px 8px;font-size:11px}.homepage-tabbed-filter .tooltip.top .tooltip-arrow{border-top-color:#cecece}", ""]);

// exports
